import React, { useState, useMemo } from 'react';
import { Select, TreeSelect } from 'antd';
import { ze } from 'utils/zhEn';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CrashAttachmentUtil } from 'utils/crash-attachment-util';
import { isPcOrLinux } from 'utils/platform';
import { CsTreeSelect } from 'components/antd-extension/CsTreeSelect';
import { ModuleListUtil } from 'components/exception/issue/ModuleList/ModuleList';
import { RegisterInfoUtil } from 'components/exception/issue/RegisterInfo/RegisterInfo';

export const AiIssueAnalysisAttachmentType = {
  ATTACHMENTS: 'ATTACHMENTS',
  REGISTERS: 'REGISTERS',
  MODULES: 'MODULES',
};

export const AiIssueAnalysisAttachmentBackendType = {
  register: 'register',
  module: 'module',
};

const AiIssueAnalysisAttachmentSelect = ({
  popupContainer,
  reduxState,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const currentIssueObj = useMemo(() => reduxState.issue.get('current').toJS(), [reduxState.issue.get('current')]) || {};
  const currentApp = reduxState.app.get('current').toJS();
  const { appId, platformId: pid, subAppType } = currentApp;
  let {
    crashDoc,
    issueExceptionType,
    attachList: mixedAttachList,
    pcStackMemoryLines: minidumpStackMemoryLines,
  } = currentIssueObj;

  const modulesTableData = useMemo(() => ModuleListUtil.getModuleListTableData(currentIssueObj, pid), [currentIssueObj, pid]);
  const registersParseResult = useMemo(() => RegisterInfoUtil.getParseResult(currentIssueObj, pid), [currentIssueObj, pid]);

  const modulesUnavailable = modulesTableData.length === 0;
  const registersUnavailable = registersParseResult.length === 0;

  const knownAttachmentFilenames = CrashAttachmentUtil.getKnownAttachmentFilenames();
  const serverKnownAttachList = isPcOrLinux(pid)
    ? (mixedAttachList || [])  // 新版PC附件全部展示
    : (mixedAttachList || []).filter(x => knownAttachmentFilenames.includes(x.fileName));
  const knownAttachList = serverKnownAttachList;

  const attachOptions = knownAttachList.map(x => {
    const { fileName } = x;
    const fileInfo = CrashAttachmentUtil.getInfoByFilename(fileName);
    return {
      title: fileInfo?.alias || fileName,
      value: fileInfo?.value || fileName,
    }
  });

  const treeData = [{
    title: ze('上报附件', 'Attachments'),
    value: AiIssueAnalysisAttachmentType.ATTACHMENTS,
    children: attachOptions,
    disabled: attachOptions.length === 0,
  }, {
    title: `${t('LASTREPORT.崩溃线程寄存器信息')}${registersUnavailable ? ze('（无数据）', ' (No data)') : ''}`,
    value: AiIssueAnalysisAttachmentType.REGISTERS,
    disabled: registersUnavailable,
  }, {
    title: `${t('LASTREPORT.加载模块信息')}${modulesUnavailable ? ze('（无数据）', ' (No data)') : ''}`,
    value: AiIssueAnalysisAttachmentType.MODULES,
    disabled: modulesUnavailable,
  }];

  return (
    <TreeSelect
      getPopupContainer={() => popupContainer}
      style={{ width: '100%' }}
      treeData={treeData}
      multiple={true}
      treeCheckable={true}
      showCheckedStrategy={TreeSelect.SHOW_CHILD}
      value={value}
      onChange={onChange}
    />
  );
};


const mapStateToProps = (state, router) => ({
  reduxState: state,
});


export default connect(mapStateToProps)(AiIssueAnalysisAttachmentSelect);
